import { lazy } from 'react'

export const ProtectiveOfPhoneVariant1 = lazy(
  () => import('./ProtectiveOfPhoneVariant1'),
)
